<template>
  <div class="about">
    <h1>☕ C☕ffee-Paste is currently in development! ☕</h1>
  </div>
</template>
